import Model from 'core/model/Model';

class TrendingView extends Model {
  get urlRoot() {
    return '/api/ui/trending-views';
  }
}

export default TrendingView;
